import '@fontsource/ibm-plex-sans-thai/400.css'
import '@fontsource/ibm-plex-sans-thai/500.css'
import '@fontsource/ibm-plex-sans-thai/600.css'
import '@fontsource/ibm-plex-sans-thai/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import './styles/base.css'
import './styles/panel.css'
import './styles/collab.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import { installLeaveInbox } from './lib/leaveInbox'
import { router } from './router'

// another page (dashboard, settings …) = no chat open: nothing gets marked read off screen
installLeaveInbox(router)

createApp(App).use(createPinia()).use(router).mount('#app')
